import {
    ArcByAngles,
    ArcByEdge,
    FollowsGeoBorder,
    GreatCircle,
    LineSegment,
    SegmentProperties,
} from "../../../../core/geo/types";
import {
    isSegmentArcByAngles,
    isSegmentArcByEdge,
    isSegmentGeoBorder,
    isSegmentGreatCircle,
} from "../../../../core/geo/assertions";
import * as _ from "lodash";

const greatCircleRequiredProps = [SegmentProperties.POINT, SegmentProperties.INDEX];
const arcByEdgeRequiredProps = [SegmentProperties.POINT, SegmentProperties.INDEX, SegmentProperties.ARC_POINT];
const arcByAnglesRequiredProps = [
    SegmentProperties.INDEX,
    SegmentProperties.CENTER,
    SegmentProperties.RADIUS,
    SegmentProperties.BEARING_1,
    SegmentProperties.BEARING_2,
];
const followsGeoBorderRequiredProps = [
    SegmentProperties.POINT,
    SegmentProperties.INDEX,
    SegmentProperties.GEO_BORDER_ID,
];

export const pickSegmentFields = (segment: LineSegment) => {
    if (isSegmentGreatCircle(segment)) {
        segment = {
            type: segment.type,
            properties: _.pick({ ...segment.properties }, greatCircleRequiredProps) as GreatCircle,
        };
    }
    if (isSegmentArcByEdge(segment)) {
        segment = {
            type: segment.type,
            properties: _.pick({ ...segment.properties }, arcByEdgeRequiredProps) as ArcByEdge,
        };
    }
    if (isSegmentArcByAngles(segment)) {
        segment = {
            type: segment.type,
            properties: _.pick({ ...segment.properties }, arcByAnglesRequiredProps) as ArcByAngles,
        };
    }
    if (isSegmentGeoBorder(segment)) {
        segment = {
            type: segment.type,
            properties: _.pick({ ...segment.properties }, followsGeoBorderRequiredProps) as FollowsGeoBorder,
        };
    }

    return segment;
};
